import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { SectionPager } from '../components/SectionPager';
import { Reveal } from '../components/Reveal';
const principles = [{
  number: 'I',
  title: 'Strategic vision',
  body: 'Align innovation with corporate strategy, financial performance, and enterprise value — a roadmap that cannot be defended in the boardroom is not a strategy.'
}, {
  number: 'II',
  title: 'Customer-centric innovation',
  body: 'Institutionalize the customer voice through advisory boards, focus groups, and continuous feedback loops that feed directly into roadmap and pricing decisions.'
}, {
  number: 'III',
  title: 'Empowerment',
  body: 'Product Managers operate as business leaders and general managers of their product lines, accountable for outcomes rather than output.'
}, {
  number: 'IV',
  title: 'Accountability',
  body: 'Operational excellence and measurable commercial results — bookings, ASP, retention, and customer success — are the scoreboard for product leadership.'
}, {
  number: 'V',
  title: 'Continuous learning',
  body: 'Markets, architectures, and buyer expectations shift; disciplined learning keeps the portfolio ahead of the transition rather than behind it.'
}];
export function Philosophy() {
  return <>
      <PageHeader number="09" title="Leadership Philosophy" blurb="How product leadership is practiced, and what it is accountable for." data-id="element-345" data-mp="140rcydxb6wg4" />

      <section className="bg-navy py-20 text-paper lg:py-24" data-id="element-346" data-mp="1won6j9rl088o">
        <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-347" data-mp="1roio3e7453ft">
          <Reveal data-id="element-348" data-mp="1rmxx1yk0c2mp">
            <p className="max-w-3xl font-display text-2xl font-light leading-[1.6] lg:text-[1.85rem]" data-id="element-349" data-mp="1rqllijalhyuk">
              Exceptional executive leadership requires aligning innovation with corporate
              strategy, financial performance, customer success, operational excellence, and
              enterprise value.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-paper py-20 lg:py-24" data-id="element-350" data-mp="cs7nh5l5aasf">
        <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-351" data-mp="hr12j2g2y9up">
          <ol data-id="element-352" data-mp="hoeteydjjmad">
            {principles.map((p, i) => <Reveal key={p.title} delay={Math.min(i * 0.04, 0.16)} data-id="element-353" data-mp="3popozw7uod1" data-mpi={i}>
                <li className="grid gap-4 border-t border-navy/15 py-9 lg:grid-cols-12 lg:gap-16" data-id="element-354" data-mp="8pkv93kkanup">
                  <div className="flex items-baseline gap-5 lg:col-span-4" data-id="element-355" data-mp="3q5svweg4f8do">
                    <span className="font-display text-sm text-gold" data-id="element-356" data-mp="3q4hvmolvwirb">{p.number}</span>
                    <h2 className="font-display text-2xl font-light text-navy" data-id="element-357" data-mp="3uz470rryubbe">{p.title}</h2>
                  </div>
                  <p className="text-[15px] leading-[1.8] text-steel lg:col-span-8" data-id="element-358" data-mp="3l77vadwyimop">{p.body}</p>
                </li>
              </Reveal>)}
          </ol>

          <Reveal data-id="element-359" data-mp="3788ic3it3w8d">
            <p className="mt-14 max-w-3xl border-l-2 border-gold pl-6 text-[15px] leading-[1.85] text-navy/85" data-id="element-360" data-mp="379t0etnxpmpc">
              I am most effective in organizations undergoing transformation, growth, M&amp;A, or
              technology modernization — environments where disciplined product leadership and
              cross-functional alignment create durable competitive advantage.
            </p>
          </Reveal>
        </div>
      </section>

      <SectionPager current="/philosophy" data-id="element-361" data-mp="2xjkzkfyid6aa" />
    </>;
}